import { render } from "./cambiocontrasena.vue?vue&type=template&id=1a4adcad"
import script from "./cambiocontrasena.vue?vue&type=script&lang=js"
export * from "./cambiocontrasena.vue?vue&type=script&lang=js"

import "./cambiocontrasena.vue?vue&type=style&index=0&id=1a4adcad&lang=scss"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__